export default {
  productListGift: '赠品配置',
  title: '标题',
  sku: 'SKU#',
  listing: 'Listing#',
  addDate: 'Add Date',
  giftDate: '赠品日期',
  giftUsage: '赠品管理',
  giftOption: '设置赠品属性',
  all: '全部',
  hasGift: '有赠品',
  noGift: '无赠品',
  giftOnly: '仅作赠品',
  giftSale: '可销售也可作赠品',
  saleOnly: '仅可销售',
  find: 'Find',
  search: '搜索',
  spec: '规格',
  price: '价格',
  gift: '赠品',
  sale: 'Sale',
  operation: '操作',
  setAsGift: 'Set As Gift',
  usage: 'Usage',
  settingGift: '配置赠品',
  settingGifts: 'Setting Gifts',
  option: 'Option',
  settingGiftForListing: 'Setting Gift for Sku#',
  chooseGift: 'Choose Gift',
  productInfo: 'Product Info',
  product: '商品',
  store: 'Store#',
  name: 'Name',
  creation: 'Creation',
  batchFill: '批量填充',
  per: '每买',
  promise: '承诺数',
  fill: 'Fill',
  remain: '剩余数',
  period: '有效期',
  alreadyUsed: 'Already Used',
  remove: '移除',
  availTillNoGiftStock: 'Avail till No Gift Stock',
  updateOption: 'Update Option',
  filterForSalesItems: 'Filter For Sales Items',
  filterForGifts: 'Filter For Gifts',
  expired: '是否过期?',
  available: 'Available',
  forSalesItem: 'For Sales Item',
  salesItem: 'Sales Item',
  country: 'Country',
  reset: 'Reset',
  brandSelect: 'Brand选择',
  periodSelect: 'Period Select',
  inventory: '库存',
  tip_li1_settings: '每买/赠送/承诺数的设置值意义是：',
  tip_li1_per: '每买: 每购买[每买]件',
  tip_li1_gift: '赠送: 当每购买[每买]个时赠送[赠送]件',
  tip_li1_promise: '承诺数: 赠送总量,赠完当前赠品活动结束',
  tip_li2: '有效期指赠送的活动有效期. 当然如果有效期内赠送的[承诺数]数量已用完也会结束当前赠品活动',
  tip_li3: '勾选某个赠品并保存表示将此赠品设置为主商品的赠送活动中。移除勾选表示此赠品从活动中移除',
  tip: '提示',
  confirmToRemove: '确认删除?',
  categoryStore: '店内分类',
  giftsStatus: '赠品状态',
  brand: '品牌',
  createDate: '商品创建时间',
  skuId: 'SKU ID',
  sku2: 'SKU',
  productName: '商品名称',
  type: '类型',
  listingId: 'Listing ID',
  availableInventory: '可售库存',
  resetFilter: '重置筛选',
  salesProductFIlter: '销售商品筛选',
  giftFilter: '赠品筛选',
  remainQty: '剩余件数',
  moreThan0: '大于0',
  rules: '规则',
  yes: '是',
  no: '否',
  salesProduct: '销售商品',
  howToSetUpGiftsForProducts: '如何设置赠品？设置参数的含义是什么？',
  howToHandleTheHistorical: '如何处理该商品的历史赠品设置？',
  keepHistoricalGift: '保留历史赠品设置直至承诺的件数售罄或过期',
  cancelAllHistorical: '取消所有历史的赠品设置',
  operateSuccessful: '操作成功',
  pleaseInputGift: '请输入赠品{0}每次赠送的件数',
  pleaseInputAwayNumber: '请输入赠品{0}承诺可赠送总件数',
  pleaseInputGiftTime: '请输入赠品{0}的有效期',
  sendGift: '赠送'
}
